let API_URL = 'https://api.timezone.io'
if (process.env.NODE_ENV !== 'production') {
  API_URL = 'http://localhost:4000'
}

export const getAPIURL = () => API_URL
